import { ModalWrapper } from '@/shared';
import React, { useEffect, useState, useRef } from 'react';
import { useHousesList } from '../../hooks/useHouseQueries';

interface AssignHouseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAssign: (managerId: string, houseIds: string[]) => void; // changed to array
  manager: { id: string; name: string };
  errors?: string[];
}

export const AssignHouseModal: React.FC<AssignHouseModalProps> = ({
  isOpen,
  onClose,
  onAssign,
  manager,
  errors,
}) => {
  const [selectedHouses, setSelectedHouses] = useState<string[]>([]);
  const [showError, setShowError] = useState(false);

  const handleAssign = () => {
    if (selectedHouses.length === 0) {
      setShowError(true);
      return;
    }
    onAssign(manager.id, selectedHouses);
    // onClose();
  };

  const handleCancel = () => {
    setSelectedHouses([]);
    setShowError(false);
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      setShowError(false);
      setSelectedHouses([]);
    }
  }, [isOpen, manager.id]);

  const { data: houses } = useHousesList();

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <div className="flex items-center justify-center w-full min-h-full">
        <div className="w-xl p-4 md:p-8 bg-white rounded-4xl">
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_183_6480)">
              <path
                d="M63.5238 25.1547L55.0917 17.9355V4.39804C55.0908 4.09197 54.9688 3.79871 54.7524 3.58229C54.536 3.36587 54.2427 3.24388 53.9366 3.24296H45.3198C45.0137 3.24388 44.7205 3.36587 44.504 3.58229C44.2876 3.79871 44.1656 4.09197 44.1647 4.39804V8.56786L35.8366 1.4295C34.7718 0.507487 33.4103 0 32.0018 0C30.5932 0 29.2318 0.507487 28.1669 1.4295L0.47979 25.1547C0.123504 25.4697 -0.129222 25.885 -0.245204 26.3461C-0.361187 26.8073 -0.335005 27.2927 -0.170096 27.7387C-0.00518686 28.1847 0.29074 28.5704 0.67883 28.8452C1.06692 29.12 1.52903 29.271 2.00449 29.2784H8.91184V51.1324C8.91306 53.7646 9.95844 56.2888 11.8186 58.1511C13.6788 60.0134 16.2017 61.0617 18.8339 61.066H33.4225C20.0144 46.7824 36.3472 24.8948 53.8558 33.6561C54.2813 33.8664 54.694 34.1017 55.0917 34.3607V29.2784H61.9991C62.4745 29.271 62.9366 29.12 63.3247 28.8452C63.7128 28.5704 64.0087 28.1847 64.1737 27.7387C64.3386 27.2927 64.3647 26.8073 64.2488 26.3461C64.1328 25.885 63.8801 25.4697 63.5238 25.1547Z"
                fill="#5761EB"
              />
              <path
                d="M55.0883 37.1789C54.3694 36.6105 53.5955 36.1152 52.7782 35.7004C50.6439 34.5812 48.2692 33.9985 45.8593 34.0025C42.991 34.0014 40.1825 34.8223 37.7662 36.3677C35.3499 37.9132 33.427 40.1186 32.2251 42.7229C31.0232 45.3272 30.5927 48.2214 30.9844 51.0628C31.3762 53.9041 32.5738 56.5738 34.4356 58.7557C35.0744 59.5061 35.7863 60.191 36.5609 60.8002C39.6933 63.2571 43.6734 64.369 47.6256 63.8914C51.5778 63.4137 55.1784 61.3856 57.6353 58.2533C60.0922 55.1209 61.2041 51.1408 60.7264 47.1886C60.2488 43.2364 58.2207 39.6358 55.0883 37.1789ZM51.6347 50.1735H47.0144V54.7938C47.0144 55.1002 46.8927 55.3939 46.6761 55.6106C46.4594 55.8272 46.1656 55.9489 45.8593 55.9489C45.5529 55.9489 45.2591 55.8272 45.0425 55.6106C44.8259 55.3939 44.7042 55.1002 44.7042 54.7938V50.1735H40.0839C39.7776 50.1735 39.4838 50.0518 39.2672 49.8352C39.0505 49.6186 38.9288 49.3248 38.9288 49.0184C38.9288 48.7121 39.0505 48.4183 39.2672 48.2017C39.4838 47.9851 39.7776 47.8634 40.0839 47.8634H44.7042V43.2431C44.7042 42.9367 44.8259 42.6429 45.0425 42.4263C45.2591 42.2097 45.5529 42.088 45.8593 42.088C46.1656 42.088 46.4594 42.2097 46.6761 42.4263C46.8927 42.6429 47.0144 42.9367 47.0144 43.2431V47.8634H51.6347C51.941 47.8634 52.2348 47.9851 52.4514 48.2017C52.668 48.4183 52.7897 48.7121 52.7897 49.0184C52.7897 49.3248 52.668 49.6186 52.4514 49.8352C52.2348 50.0518 51.941 50.1735 51.6347 50.1735Z"
                fill="#5761EB"
              />
            </g>
            <defs>
              <clipPath id="clip0_183_6480">
                <rect width="64" height="64" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <div className="py-4 md:my-8">
            <h4 className="text-xl md:text-3xl font-bold text-text-primary mb-2 ">
              Assign houses
            </h4>
            <p className="text-base md:text-xl text-text-secondary ">
              Select one or more houses to assign. The manager will be able to
              manage residents, payments, and related records for the assigned
              houses.
            </p>
          </div>

          {/* Houses Dropdown with multiple select  */}
          <div className="mb-4">
            <label htmlFor="">Houses</label>
            <MultiSelectDropdown
              options={houses || []}
              selected={selectedHouses}
              onChange={setSelectedHouses}
            />
          </div>

          {/* Error message */}
          {showError && (
            <p className="text-sm text-red-500 mb-4">
              Please select at least one house to be assigned.
            </p>
          )}

          {errors && (
            <p className="text-sm text-red-500 mb-4">
              {errors.map((err, index) => (
                <span key={index}>{err}</span>
              ))}
            </p>
          )}

          <div className="grid grid-cols-2 gap-4">
            <button
              className="p-2 text-[#5761EB] text-base md:text-lg font-bold cursor-pointer rounded-md border border-[#ffffff] hover:border-[#5761EB] transition-colors duration-200"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="p-2 text-base md:text-lg text-white font-bold rounded-md border border-[#ffffff] bg-[#5761EB] cursor-pointer transition-colors  duration-200"
              onClick={handleAssign}
            >
              Assign
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

/* ---------------- MultiSelectDropdown ---------------- */

interface Option {
  id: string;
  name: string;
}

interface MultiSelectDropdownProps {
  options: Option[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

export const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  options,
  selected,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Toggle selection
  const toggleOption = (id: string) => {
    if (selected.includes(id)) {
      onChange(selected.filter((item) => item !== id));
    } else {
      onChange([...selected, id]);
    }
  };

  // const selectedLabels =
  //   options
  //     .filter((opt) => selected.includes(opt.id))
  //     .map((opt) => opt.name)
  //     .join(', ') || 'Select houses';

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        className="w-full border border-[#5761EB] rounded-lg px-4 py-3 text-left flex justify-between items-center"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span
          className={`text-base md:text-xl ${
            selected.length ? 'text-text-secondary' : 'text-text-secondary'
          }`}
        >
          {/* {selectedLabels} */}
          Select House
        </span>

        <svg
          className={`w-4 h-4 ml-2 transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown with smooth height transition */}
      <div
        className={`transition-all duration-500 ease-in-out overflow-y-scroll scrollbar-hide`}
        style={{
          maxHeight: isOpen ? '200px' : '0px', // smooth expand/collapse
        }}
      >
        <div className="z-40 mt-2 w-full bg-white border border-[#BFBFBF] p-2 md:p-4 rounded-xl">
          {options.map((option) => (
            <label
              key={option.id}
              className="flex items-center justify-between text-base md:text-xl px-4 py-0 md:py-3 hover:bg-gray-100 cursor-pointer text-text-secondary"
            >
              <span>{option.name}</span>
              <input
                type="checkbox"
                checked={selected.includes(option.id)}
                onChange={() => toggleOption(option.id)}
                className="ml-3 accent-blue-600"
              />
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};
